module.exports = __webpack_public_path__ + "img/9f769bb340594664993afda102674cd4-640.f738d612.jpg";